/*
 * @Author: JamesWong
 * @Description: 账户配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 14:46:55
 */
export default {
  basicInformation: '基本资料',
  enterpriseNumber: '企业编号',
  enterpriseName: '企业名称'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/account.js